import React from 'react';
import { IonItem, IonLabel, IonNote, IonBadge, IonIcon } from '@ionic/react';

interface EditorSelectionItemProps {
  label: string;
  description?: string;
  badgeText?: string;
  icon?: string;
  isActive?: boolean;
  onClick: () => void;
}

const EditorSelectionItem: React.FC<EditorSelectionItemProps> = ({
  label,
  description,
  badgeText,
  icon,
  isActive = false,
  onClick
}) => {
  return (
    <IonItem
      button
      detail
      onClick={onClick}
      className={`editor-selection-item${isActive ? ' editor-selection-item--active' : ''}`}
      style={{
        '--padding-start': '0.75rem',
        '--inner-padding-end': '0.75rem',
        '--min-height': '62px'
      }}
    >
      {icon && (
        <div className="editor-selection-item__icon">
          <IonIcon icon={icon} />
        </div>
      )}
      <IonLabel>
        <h3 style={{ margin: 0, fontSize: '0.95rem' }}>{label}</h3>
        {description && (
          <IonNote style={{ display: 'block', marginTop: '0.25rem', fontSize: '0.75rem' }}>
            {description}
          </IonNote>
        )}
      </IonLabel>
      {isActive && (
        <IonBadge slot="end" color="primary">
          Current
        </IonBadge>
      )}
      {badgeText && (
        <IonBadge slot="end" color="medium">
          {badgeText}
        </IonBadge>
      )}
    </IonItem>
  );
};

export default EditorSelectionItem;
